import module from 'contabilidad/polizasexternas/module'
import template from './template.html'

export class ContabilidadPolizasexternasProvisioncomprasagComponent {

  constructor($location) {
    this.$location = $location
  }

  $onInit() { }

  $onChanges(changes) {
    if (changes.busqueda)
      this.busqueda = {
        fechaInicial: changes.busqueda.currentValue.fechaInicial || new Date(),
        fechaFinal: changes.busqueda.currentValue.fechaFinal || new Date(),
      }
  }

  buscar() {
    this.$location.search({
      fechaInicial: this.busqueda.fechaInicial.toYMD(),
      fechaFinal: this.busqueda.fechaFinal.toYMD(),
    })
  }
}

module.component('contabilidadPolizasexternasProvisioncomprasag', {
  controller: ContabilidadPolizasexternasProvisioncomprasagComponent,
  template,
  bindings: {
    busqueda: '<',
  },
})



// WEBPACK FOOTER //
// ./src/contabilidad/polizasexternas/components/provisioncomprasag/component.js